import React from 'react';
import PropTypes from 'prop-types';
import {
  Plus, BookOpen, ClipboardCheck, Clock, Upload,
} from 'lucide-react';

export default function DashboardOverview({
  onCreateCourseClick,
  onNavigateToModulesClick,
  onNavigateToAssessmentsClick,
  onNavigateToMaterialsClick,
}) {
  const recentActivities = [
    { id: 1, description: "Created new module: 'Introduction to Safety'", time: '2 hours ago' },
    { id: 2, description: "Edited assessment: 'Emergency Procedures'", time: 'Yesterday' },
    { id: 3, description: "Added 3 new questions to 'Fire Safety Basics' assessment", time: '3 days ago' },
    { id: 4, description: "Uploaded 'Safety Handbook' material", time: '1 week ago' },
  ];

  const cardClass = 'bg-white rounded-lg shadow p-6';
  const cardTitleClass = 'text-xl font-semibold text-gray-800 mb-4';
  const buttonClass = 'flex items-center w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200';
  const activityItemClass = 'flex items-start gap-3';
  const activityTextClass = 'text-sm font-medium text-gray-700';
  const activityTimeClass = 'text-xs text-gray-500';

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      <div className={`${cardClass} md:col-span-2 lg:col-span-1`}>
        <h2 className={cardTitleClass}>Quick Actions</h2>
        <div className="grid gap-4">
          <button type="button" className={buttonClass} onClick={onCreateCourseClick}>
            <Plus className="mr-2 h-4 w-4" />
            {' '}
            Create New Course
          </button>
          <button type="button" className={buttonClass} onClick={onNavigateToModulesClick}>
            <BookOpen className="mr-2 h-4 w-4" />
            {' '}
            Add New Module
          </button>
          <button type="button" className={buttonClass} onClick={onNavigateToAssessmentsClick}>
            <ClipboardCheck className="mr-2 h-4 w-4" />
            {' '}
            Create New Assessment
          </button>
          <button type="button" className={buttonClass} onClick={onNavigateToMaterialsClick}>
            <Upload className="mr-2 h-4 w-4" />
            {' '}
            Upload New Material
          </button>
        </div>
      </div>

      <div className={`${cardClass} md:col-span-2 lg:col-span-2`}>
        <h2 className={cardTitleClass}>Recent Activity</h2>
        <ul className="space-y-4">
          {recentActivities.map((activity) => (
            <li key={activity.id} className={activityItemClass}>
              <Clock className="h-5 w-5 text-gray-500 shrink-0 mt-1" />
              <div>
                <p className={activityTextClass}>{activity.description}</p>
                <p className={activityTimeClass}>{activity.time}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Placeholder for other dashboard widgets */}
      <div className={`${cardClass} md:col-span-2 lg:col-span-3`}>
        <h2 className={cardTitleClass}>Course Statistics</h2>
        <div className="h-48 w-full rounded-lg bg-gray-200 flex items-center justify-center text-gray-500">
          Charts and data will go here
        </div>
      </div>
    </div>
  );
}

DashboardOverview.propTypes = {
  onCreateCourseClick: PropTypes.func.isRequired,
  onNavigateToModulesClick: PropTypes.func.isRequired,
  onNavigateToAssessmentsClick: PropTypes.func.isRequired,
  onNavigateToMaterialsClick: PropTypes.func.isRequired,
};
